import { deriveRelevantScheduleEvents } from "./_logic/scheduleProjection"

export const coerceEntityList = <T extends { id?: string | null }>(
  value: T[] | Record<string, unknown> | null | undefined,
) => {
  if (Array.isArray(value)) return value

  if (value && typeof value === "object") {
    const items = (value as { items?: unknown }).items

    if (Array.isArray(items)) return items.filter(Boolean) as T[]

    return Object.values(value).filter((entry): entry is T =>
      Boolean(entry && typeof entry === "object" && !Array.isArray(entry)),
    )
  }

  return []
}

export const indexById = <T extends { id?: string | null }>(
  value: T[] | Record<string, unknown> | null | undefined,
): Record<string, T> =>
  Object.fromEntries(
    coerceEntityList(value)
      .filter((entry): entry is T & { id: string } => Boolean(entry?.id))
      .map((entry) => [entry.id, entry]),
  )

export const mergeById = <T extends { id?: string | null }>(
  existing: T[] | Record<string, unknown> | null | undefined,
  incoming: T[] | Record<string, unknown> | null | undefined,
) => {
  const existingList = coerceEntityList(existing)
  const incomingList = coerceEntityList(incoming)

  if (!incomingList.length) return existingList

  const map = new Map<string, T>()
  existingList.forEach((entry) => entry?.id && map.set(entry.id, entry))
  incomingList.forEach((entry) => entry?.id && map.set(entry.id, entry))

  return Array.from(map.values())
}

export const rebuildRelevantScheduleEvents = (
  events: ScheduleEvent[] | Record<string, ScheduleEvent> | null | undefined,
) => {
  const filteredEvents = coerceEntityList(events).filter((event) => Boolean(event.work_order_id))

  return deriveRelevantScheduleEvents(filteredEvents)
}
